import { lazy, Suspense, useEffect, useState, type ComponentProps } from "react";

const LazySpotMap = lazy(() =>
  import("@/components/SpotMap").then((m) => ({ default: m.SpotMap })),
);

export function SpotMapClient(props: ComponentProps<typeof LazySpotMap>) {
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);

  if (!mounted) {
    return (
      <div
        className="grid h-[480px] w-full place-items-center rounded-2xl border border-[var(--electric)]/15 bg-[var(--navy-deep)]/60 text-sm text-[var(--offwhite-warm)]"
        aria-label="Loading fishing map"
      >
        Loading interactive fishing map…
      </div>
    );
  }

  return (
    <Suspense
      fallback={
        <div className="grid h-[480px] w-full place-items-center rounded-2xl border border-[var(--electric)]/15 bg-[var(--navy-deep)]/60 text-sm text-[var(--offwhite-warm)]">
          Loading interactive fishing map…
        </div>
      }
    >
      <LazySpotMap {...props} />
    </Suspense>
  );
}
